import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIResult, emptyAPIResult, loadingAPIResult, successAPIResult, errorAPIResult } from "../../lib/redux";
import { Order, OrderStatus } from "../../models";
import { triplePSDatasource } from "../../datasource";
import { OrderFilters } from "../../datasource/TriplePService/TriplePInterface";

const CURRENT = [
  OrderStatus.OrderStatusCreated, OrderStatus.OrderStatusScheduled,
  OrderStatus.OrderStatusDelivered, OrderStatus.OrderStatusScheduledToPickup,
  OrderStatus.OrderStatusPickedUp,
];
const PENDING = [OrderStatus.OrderStatusReceived];
const COMPLETE = [OrderStatus.OrderStatusComplete];

interface CustomerOrdersState {
  activeOrders: Order[]; pendingOrders: Order[]; completedOrders: Order[];
  activeResult: APIResult<Order[]>; pendingResult: APIResult<Order[]>; completedResult: APIResult<Order[]>;
}
const initialState: CustomerOrdersState = {
  activeOrders: [], pendingOrders: [], completedOrders: [],
  activeResult: emptyAPIResult(), pendingResult: emptyAPIResult(), completedResult: emptyAPIResult(),
};

export const getCustomerActiveOrders = createAsyncThunk(
  "customerOrders/active",
  async (params: { userId: string; offset: number; count: number }) => {
    const filters: OrderFilters = { statuses: CURRENT, userId: params.userId, sort: "recent" };
    return triplePSDatasource.getOrders(filters, { offset: params.offset, count: params.count });
  }
);
export const getCustomerPendingOrders = createAsyncThunk(
  "customerOrders/pending",
  async (params: { userId: string; offset: number; count: number }) => {
    const filters: OrderFilters = { statuses: PENDING, userId: params.userId, sort: "recent" };
    return triplePSDatasource.getOrders(filters, { offset: params.offset, count: params.count });
  }
);
export const getCustomerCompletedOrders = createAsyncThunk(
  "customerOrders/completed",
  async (params: { userId: string; offset: number; count: number }) => {
    const filters: OrderFilters = { statuses: COMPLETE, userId: params.userId, sort: "recent" };
    return triplePSDatasource.getOrders(filters, { offset: params.offset, count: params.count });
  }
);

export const customerOrdersSlice = createSlice({
  name: "customerOrders",
  initialState,
  reducers: {},
  extraReducers: (b) => {
    b.addCase(getCustomerActiveOrders.pending, (s) => { s.activeResult = loadingAPIResult(); })
     .addCase(getCustomerActiveOrders.fulfilled, (s, a) => { s.activeResult = successAPIResult(a.payload); s.activeOrders = a.payload; })
     .addCase(getCustomerActiveOrders.rejected, (s, a) => { s.activeResult = errorAPIResult(a.error); })
     .addCase(getCustomerPendingOrders.pending, (s) => { s.pendingResult = loadingAPIResult(); })
     .addCase(getCustomerPendingOrders.fulfilled, (s, a) => { s.pendingResult = successAPIResult(a.payload); s.pendingOrders = a.payload; })
     .addCase(getCustomerPendingOrders.rejected, (s, a) => { s.pendingResult = errorAPIResult(a.error); })
     .addCase(getCustomerCompletedOrders.pending, (s) => { s.completedResult = loadingAPIResult(); })
     .addCase(getCustomerCompletedOrders.fulfilled, (s, a) => { s.completedResult = successAPIResult(a.payload); s.completedOrders = a.payload; })
     .addCase(getCustomerCompletedOrders.rejected, (s, a) => { s.completedResult = errorAPIResult(a.error); });
  },
});

export default customerOrdersSlice.reducer;
